/**
 * CIN-15667: Turnstile checks the hostname of the document that renders the widget, and the free plan
 * allows 10 hostnames per widget against 57+ cinema domains. So the widget renders in a frame served
 * from this one fixed host (`src/app/captcha/route.ts`), which every cinema domain embeds.
 */
export const CAPTCHA_HOST = `captcha.${process.env.CIN_DOMAIN}`;
export const CAPTCHA_ORIGIN = `https://${CAPTCHA_HOST}`;
export const CAPTCHA_FRAME_PATH = '/captcha';
/** `type` of the messages the frame posts to the embedding page. */
export const CAPTCHA_MESSAGE_TYPE = 'cineamo-turnstile';
